module.exports = __webpack_public_path__ + "img/eloquence-screenshot.888be4a0.png";